import { toastError } from "../redux/guest-slices/other.slice"
import { jwtDecode } from "jwt-decode"
import { Cookies } from "react-cookie"
import router from "../routes/routes"
import moment from "moment-timezone"
import TimeUtils from "./time.utils"

const cookies = new Cookies()

export function formatPrice(price, currency = "usd") {

  if (price == null || Number.isNaN(Number(price))) return null;

  let normalizedCurrency = (currency || "usd").toUpperCase();
  if (normalizedCurrency === "IND") normalizedCurrency = "INR";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: normalizedCurrency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(price));
}

export function getCurrencySymbol(currency = "usd") {
  try {
    let normalized = (currency || "usd").toUpperCase();
    if (normalized === "IND") normalized = "INR";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: normalized,
    }).formatToParts(0).find(part => part.type === "currency")?.value || "$";
  } catch (e) {
    return "$";
  }
}


// export const BASEURI = "http://localhost:5000/v1/api"
// export const SOCKET_BASEURI = "http://localhost:5001"
// export const FILE_PATH_URI = "http://localhost:5000/src/uploads/"

export const BASEURI = process.env.REACT_APP_BASEURI
export const FILE_PATH_URI = process.env.REACT_APP_FILE_PATH_URI
export const SOCKET_BASEURI = process.env.REACT_APP_SOCKET_BASEURI

export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID

export const getDiffTime = (time) => {
  const targetTime = moment(time)
  const currentTime = moment()
  const diffInDays = currentTime.diff(targetTime, "days")
  const diffInHours = currentTime.diff(targetTime, "hours")
  const diffInMinutes = currentTime.diff(targetTime, "minutes")

  if (Math.abs(diffInMinutes) < 60) {
    return `${diffInMinutes}m`
  } else if (Math.abs(diffInHours) < 24) {
    return `${diffInHours}h`
  } else {
    return `${diffInDays}d`
  }
}

export const checkUserType = () => {
  const token = cookies.get("token")
  try {
    if (token) {
      const decodedToken = jwtDecode(token)
      return decodedToken?.userRole
    } else {
      return false
    }
  } catch (error) {
  }
}

export const checkToken = (dispatch) => {
  const token = cookies.get("token")
  try {
    if (token) {
      const decodedToken = jwtDecode(token)
      const { userRole, exp } = decodedToken
      const valid = exp * 1000 > Date.now()
      if (valid) {
        return { userRole, valid }
      } else {
        cookies.remove("token", { path: "/" })
        if (dispatch) {
          dispatch({ type: "Logout", payload: "" })
          dispatch(toastError("Token expired. Please login again!"))
        }
        return false
      }
    } else {
      return false
    }
  } catch (error) {
    const errorMessage = error?.message?.split(":")[0]
    if (dispatch) {
      dispatch(toastError(errorMessage))
    }
  }
}

export const checkTokenErr = (err, dispatch) => {
  if (err.response.data.redirect) {
    cookies.remove("token", { path: "/" })
    dispatch({ type: "Logout", payload: "" })
    router.navigate(err.response.data?.location)
  }
}

export const headers = () => {
  return {
    "withCredentials": true,
    "credentials": "include",
    "Content-Type": "application/json",
    "timezone": TimeUtils.getCurrentTimezone(),
    "Authorization": `Bearer ${cookies.get("token")}`,
  }
}

export const loadFbSdk = () => {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve()
      return
    }
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v14.0"
      });
      resolve();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js"
      fjs.parentNode.insertBefore(js, fjs)
    }(document, "script", "facebook-jssdk"))

    setTimeout(() => {
      if (!window.FB) {
        reject(new Error("SDK could not be loaded."))
      }
    }, 5000)
  })
}

export const slickSettings = {
  speed: 1000,
  arrows: false,
  infinite: true,
  initialSlide: 0,
  slidesToShow: 3,
  autoplaySpeed: 0,
  slidesToScroll: 1,
}

export const acceptAllCookies = () => {
  const oneYear = 365 * 24 * 60 * 60
  cookies.set("essentialCookies", "accepted", { path: "/", maxAge: oneYear })
  cookies.set("analyticsCookies", "accepted", { path: "/", maxAge: oneYear })
  cookies.set("marketingCookies", "accepted", { path: "/", maxAge: oneYear })
  cookies.set("functionalCookies", "accepted", { path: "/", maxAge: oneYear })
}

export const rejectAllCookies = () => {
  const oneYear = 365 * 24 * 60 * 60

  cookies.set("essentialCookies", "rejected", { path: "/", maxAge: oneYear })
  cookies.set("analyticsCookies", "rejected", { path: "/", maxAge: oneYear })
  cookies.set("marketingCookies", "rejected", { path: "/", maxAge: oneYear })
  cookies.set("functionalCookies", "rejected", { path: "/", maxAge: oneYear })
}
export const handleDownload = async (doc) => {
  try {
    const response = await fetch(doc?.fileURL || doc);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = doc?.fileName || "downloaded-file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed", error);
  }
}
export const debounce = (func, delay = 500) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func(...args), delay)
  }
}
export const processAvailabilityOnFrontend = (data, userTimeZone) => {

  if (data?.schedules) {
    return {
      weeklySchedule: Object.entries(data.schedules || {}).map(([day, slots]) => ({
        day: day,
        slots: slots
      })),
      bookedSlots: data?.bookedSlots || [],
      bookingInfo: data?.bookingInfo || [],
      exceptions: data?.exceptions || [],
      specialistTimeZone: data?.specialistTimeZone,
      slotDuration: data?.slotDuration
    };
  }

  if (data?.dayWiseAvailability) {
    const convertedSchedules = {};

    data?.dayWiseAvailability?.forEach(daySchedule => {
      daySchedule.slots?.forEach(slot => {
        if (!slot?.startTime || !slot?.endTime) return;

        const slotStartMoment = moment(slot?.startTime);
        const slotEndMoment = moment(slot?.endTime);

        if (!slotStartMoment.isValid() || !slotEndMoment.isValid()) {
          console.error('Invalid slot time:', slot);
          return;
        }

        const slotStartInUserTZ = slotStartMoment.clone().tz(userTimeZone);
        const slotEndInUserTZ = slotEndMoment.clone().tz(userTimeZone);

        const userDay = slotStartInUserTZ.format("dddd").toUpperCase();

        if (!convertedSchedules[userDay]) {
          convertedSchedules[userDay] = {
            day: userDay,
            scheduleId: daySchedule?.scheduleId,
            slots: []
          };
        }

        convertedSchedules[userDay].slots.push({
          startTime: slotStartInUserTZ.format("HH:mm"),
          endTime: slotEndInUserTZ.format("HH:mm"),
          startTimeISO: slotStartInUserTZ.toISOString(),
          endTimeISO: slotEndInUserTZ.toISOString(),
          originalDay: daySchedule?.day,
          originalStartTime: slot?.startTime,
          originalEndTime: slot?.endTime
        });
      });
    });

    const convertedBookedSlots = (data?.bookedSlots || []).map(isoTimestamp => {
      const bookedMoment = moment(isoTimestamp);

      if (!bookedMoment.isValid()) {
        console.error('Invalid booked slot timestamp:', isoTimestamp);
        return null;
      }

      const bookedInUserTZ = bookedMoment.clone().tz(userTimeZone);

      const userDay = bookedInUserTZ.format("dddd").toUpperCase();
      const userDate = bookedInUserTZ.format("YYYY-MM-DD");
      const userTime = bookedInUserTZ.format("HH:mm");

      return `${userDay}_${userDate}T${userTime}`;
    }).filter(Boolean);

    const weeklySchedule = Object.values(convertedSchedules).map(daySchedule => ({
      ...daySchedule,
      slots: (daySchedule?.slots ?? []).sort(
        (a, b) => a?.startTime?.localeCompare(b?.startTime)
      )
    }));

    return {
      weeklySchedule,
      bookedSlots: convertedBookedSlots,
      bookingInfo: data?.bookingInfo || [],
      exceptions: data?.exceptions || [],
      specialistTimeZone: data?.specialistTimeZone,
      slotDuration: data?.slotDuration,
      userTimeZone: userTimeZone
    };
  }

  // Fallback
  return {
    weeklySchedule: [],
    bookedSlots: [],
    bookingInfo: [],
    exceptions: [],
    specialistTimeZone: null,
    slotDuration: 30,
    userTimeZone: userTimeZone
  };
};



export const countries = [
  {
    "id": 101,
    "name": "India",
    "iso3": "IND",
    "iso2": "IN",
    "numeric_code": "356",
    "phone_code": "91",
    "capital": "New Delhi",
    "currency": "INR",
    "currency_name": "Indian rupee",
    "currency_symbol": "₹",
    "tld": ".in",
    "native": "भारत",
    "region": "Asia",
    "subregion": "Southern Asia",
    "latitude": "20.00000000",
    "longitude": "77.00000000",
    "emoji": "🇮🇳",
    "hasStates": true
  },
  {
    "id": 233,
    "name": "United States",
    "iso3": "USA",
    "iso2": "US",
    "numeric_code": "840",
    "phone_code": "1",
    "capital": "Washington",
    "currency": "USD",
    "currency_name": "United States dollar",
    "currency_symbol": "$",
    "tld": ".us",
    "native": "United States",
    "region": "Americas",
    "subregion": "Northern America",
    "latitude": "38.00000000",
    "longitude": "-97.00000000",
    "emoji": "🇺🇸",
    "hasStates": true
  },
]

export const timezoneMapping = {
  "IN": ["Asia/Kolkata"],
  "US": ["America/Los_Angeles",
    "America/Denver",
    "America/Chicago",
    "America/New_York",
    "America/Anchorage",
    "Pacific/Honolulu"],
};

function getMemberCurrency(userTz) {
  if (!userTz) return "usd";
  const tzLower = userTz.toLowerCase();
  if (tzLower === "asia/calcutta" || tzLower === "asia/kolkata") {
    return "inr";
  }
  if (
    tzLower.startsWith("america/") ||
    tzLower.startsWith("us/") ||
    tzLower.startsWith("pacific/honolulu")
  ) {
    return "usd";
  }
  return "usd";
}

/**
 * Converts price from USD to local currency (INR) or vice-versa
 * based on specialist profile currency and member's timezone.
 * 
 * @param {number|string} price - Original Price
 * @param {number} rate - USD to INR exchange rate (from database)
 * @param {string} [currency] - Specialist currency (defaults to 'usd')
 * @returns {{ price: number, currency: string }} Converted price and currency
 */
export function getLocalPrice(price, rate = 1, currency = "usd") {
  if (price == null || Number.isNaN(Number(price))) {
    return { price: 0, currency };
  }
  let specCurrency = (currency || "usd").toLowerCase();
  if (specCurrency === "ind") specCurrency = "inr";

  const userTz = TimeUtils.getCurrentTimezone();
  const memberCurrency = getMemberCurrency(userTz);

  if (specCurrency === "usd" && memberCurrency === "inr") {
    // Convert USD to INR
    return {
      price: Number(price) * rate,
      currency: "inr",
    };
  } else if (specCurrency === "inr" && memberCurrency === "usd") {
    // Convert INR to USD
    return {
      price: Number(price) / rate,
      currency: "usd",
    };
  }

  // Same currency, or other combination -> no conversion
  return {
    price: Number(price),
    currency: specCurrency,
  };
}

/**
 * Converts price based on specialist profile currency and member's timezone,
 * and formats it using formatPrice.
 * 
 * @param {number|string} price - Original Price
 * @param {number} rate - USD to INR exchange rate (from database)
 * @param {string} [currency] - Specialist currency (defaults to 'usd')
 * @returns {string} Formatted price label
 */
export function formatLocalPrice(price, rate = 1, currency = "usd") {
  const local = getLocalPrice(price, rate, currency);
  return formatPrice(local.price, local.currency);
}
